import styled from '@emotion/styled';
import { alphaHex, colors } from '@/constants/colors';

type GnbDropDownProps = {
  position?: string,
  top?: number,
  left?: number,
};

export const GnbDropDownItemDiv = styled.div<GnbDropDownProps>`
position: ${({ position }) => position};
z-index: 10;
top: ${({ top }) => top ?? 0}px;
left: ${({ left }) => left ?? 0}px;
display: grid;
min-width: 150px;
padding: 7.5px 0;
border: 1px solid ${colors.brightGrey2};
background-color: ${colors.white};
border-radius: 10px;
box-shadow: 0px 6px 15px ${colors.darkGrey}${alphaHex(0.05)};
`;

export const GnbDropDownSpan = styled.span`
display: block;
padding: 7.5px 18px;
color: ${colors.blackGrey};
cursor: pointer;
font-size: 14px;
font-weight: 700;
line-height: 20px;

&:hover {
  color: ${colors.black}
}

&:active {
  color: ${colors.blue}
}
`;
